<template>
  <div style="width: 100%;height: 100%">
    <div v-if="chapter.videos && chapter.videos.length !== 0 && chapter.videos[0].videoUrl && chapter.videos[0].videoUrl !== ''" style="width: 100%;height: 100%">
      <div style="width: 100%;height: 16px">
        <i title="删除视频" class="el-icon-circle-close" style="float: right;height: 100%;padding-left: 5px" @click="handleRemove"></i>
        <el-upload
          style="float: right;height: 100%"
          ref="editFile"
          :limit="1"
          accept=".mp4"
          action
          :file-list="editFileList"
          :show-file-list="false"
          :before-upload="beforeUpload"
          :http-request="fileEditChange"
          :on-success="handleSuccess"
          :on-exceed="handleExceed"
          :on-error="handleError">
          <i title="更换视频" class="el-icon-edit-outline"></i>
        </el-upload>
      </div>
      <el-row style="height: calc(100% - 16px)">
        <el-col :span="16" style="height: 100%">
          <video
            :src="chapter.videos[0].videoUrl"
            preload="metadata"
            class="video-avatar"
            controls="controls">
          </video>
        </el-col>
        <el-col :span="8" style="height: 100%">
          <div style="width: calc(100% - 15px);height: calc(100% - 30px);margin: 30px 5px 0 10px">
            <vue-qr style="width: 100%;height: 100%" :text="chapter.videos[0].qrCode"></vue-qr>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-upload
      v-else
      ref="file"
      class="avatar-uploader-drag"
      drag
      :limit="1"
      accept=".mp4"
      action
      :file-list="chapter.fileList"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :http-request="fileChange"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :on-error="handleError">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text" style="font-size: 14px">
        <div>将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" style="text-align: center;font-size: 14px" slot="tip">只能上传mp4文件，且不超过1GB</div>
      </div>
    </el-upload>
  </div>
</template>

<script>
import {addVideo, delVideo, editVideo} from '../../api/video'
import VueQr from 'vue-qr'

export default {
  name: 'uploadVideo',
  components: {VueQr},
  props: {
    chapterObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      chapter: '',
      editFileList: []
    }
  },
  created () {
    this.chapter = this.chapterObj
    // console.log(this.chapter)
  },
  methods: {
    handleRemove () {
      this.$confirm('此操作将永久删除该视频, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(res => {
        let id = this.chapter.videos[0].id
        delVideo(id).then(res => {
          this.$message({
            message: '成功删除视频',
            type: 'success'
          })
          this.chapter.videos = []
        })
      })
    },
    // 上传文件
    // 开始上传前验证
    beforeUpload (file) {
      // 验证文件大小
      // if (file.size / 1024 / 1024 > this.formMaxSize) {
      //   this.$message({
      //     message: `上传文件大小不能超过${this.formMaxSize}M!`,
      //     type: 'warning'
      //   })
      //   return false
      // }
      // 中文乱码处理
      // if (file.raw) {
      //   let reader = new FileReader() // 读取文件内容
      //   reader.readAsText(file.raw, 'gb2312') // 防止中文乱码问题，不加reader.onload方法都不会触发
      //   reader.onload = function (e) {
      //     this.contentHtml = e.target.result // txt文本内容，接下来就可以对其进行校验处理了
      //   }
      // }
      // 验证文件类型
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'mp4'
      if (!extension) {
        this.$message({
          message: '上传文件只能是mp4格式!',
          type: 'warning'
        })
      }
      return extension
    },
    // beforeEditUpload (file) {
    //   this.$confirm('此操作将替换更新原视频, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(res => {
    //     // 验证文件类型
    //     var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
    //     const extension = testmsg === 'mp4'
    //     if (!extension) {
    //       this.$message({
    //         message: '上传文件只能是mp4格式!',
    //         type: 'warning'
    //       })
    //     }
    //     return extension
    //   }).catch(() => {
    //     this.editFileList = []
    //     return false
    //   })
    // },
    fileChange (file, fileList) {
      // if (file.name.split('.')[file.name.split('.').length - 1] !== 'mp4') {
      //   vm.$message({type: 'error', message: '不支持该文件类型！'})
      //   this.$refs['file'].clearFiles()
      //   // return
      // }
      // this.activeIndex = this.typeId
      this.sendUpload(file.file)
    },
    fileEditChange (file, fileList) {
      console.log(file)
      this.sendEditUpload(file.file)
    },
    // 文件超出个数限制时的钩子
    handleExceed (files, fileList) {
      this.$message.warning(`只能选择1个文件。`)
    },
    handleSuccess (res, file, fileList) {
      this.$message.success('文件上传成功')
    },
    // eslint-disable-next-line handle-callback-err
    handleError (err, file, fileList) {
      this.$message.error('文件上传失败')
    },
    sendUpload (file) {
      let that = this
      let body = {
        bookId: this.chapter.bookId,
        chapterId: this.chapter.id,
        desc: '',
        note: '',
        file: file
      }
      addVideo(body).then(res => {
        this.$notify({
          title: '成功',
          message: '成功上传。',
          type: 'success'
        })
        that.chapter.videos.push(res.data)
      })
    },
    sendEditUpload (file) {
      let that = this
      let body = {
        bookId: this.chapter.bookId,
        chapterId: this.chapter.id,
        code: this.chapter.videos[0].code,
        qrCode: this.chapter.videos[0].qrCode,
        desc: '',
        note: '',
        file: file
      }
      editVideo(body, this.chapter.videos[0].id).then(res => {
        this.$notify({
          title: '成功',
          message: '成功更新视频。',
          type: 'success'
        })
        that.chapter.videos = []
        that.chapter.videos.push(res.data)
      })
    }
  }
}
</script>

<style>
  .avatar-uploader-drag{
    width: 100%;
    height: 100%;
  }
  .avatar-uploader-drag .el-upload{
    width: 100%;
    height: 100%;
  }
  .avatar-uploader-drag .el-upload .el-upload-dragger{
    width: 100%;
    height: 100%;
  }
  .avatar-uploader-drag .el-upload .el-upload-dragger .el-icon-upload{
    font-size: 60px;
    margin: 20px;
  }

  .video-avatar {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  .el-icon-circle-close {
    display: flex;
    float: right;
    margin-right: 6px;
    color: #959bcb;
    font-size: 16px;
    cursor: pointer;
  }
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/materialManagement/uploadVideo.vue